// extracted by mini-css-extract-plugin
var _1 = "SearchHighlight-module__highlight--FMZBz";
export { _1 as "highlight" }
